import Employee from "../../../app/domain/Employee";

export default function adaptEmployees({ employees }: { employees: any[] }) {
  const keys = ({
    id,
    internalId,
    costCenter,
    payrollCompany,
    name,
    firstSurname,
    secondSurname,
    surname,
    legalId,
    email,
    grossSalary,
    hiringDate,
    state,
    taxRegime,
    error,
    warning,
    modelId,
  }: {
    id: string;
    internalId: string;
    costCenter: string;
    payrollCompany: string;
    name: string;
    firstSurname: string;
    secondSurname: string;
    surname: string;
    legalId: string;
    email: string;
    grossSalary: string;
    hiringDate: string;
    state: string;
    taxRegime: string;
    error: string;
    warning: string;
    modelId: string;
  }) => ({
    id,
    internalId,
    costCenter,
    payrollCompany,
    name,
    firstSurname,
    secondSurname,
    surname,
    legalId,
    email,
    grossSalary,
    hiringDate,
    state,
    taxRegime,
    error,
    warning,
    modelId,
  });
  return employees.map((employee) => new Employee(keys(employee)));
}
